module.exports = __webpack_public_path__ + "static/akinsete-5c42b6bd84ef8da0e6e0b3e91820c214.jpg";